import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { getBrText } from "../../helpers/helper.rendering";

const Team = () => {

    const { realEstate } = useStaticQuery(graphql`
     query {
         realEstate {
             sections {
                 about {
                    team {
                        hidden
                        title
                        paragraph
                        subtitle
                        image
                        hiddenItems
                        items{
                            name
                            type
                            broker_id
                        }
                    }
                }
             }
         }
     }`)

     console.log(realEstate.sections.about.team.hiddenItems)

    return realEstate.sections ? (
        !realEstate.sections.about.team.hidden && (
            <section className="the-team" style={{backgroundImage:"url("+ realEstate.sections.about.team.image +")"}}>
                <div className="opacity"></div>
                <div className="container-fluid position-relative">
                    <div className="row">
                        <div className="col-lg-2">
                            <p className="section-name">
                                {realEstate.sections.about.team.title}
                            </p>
                        </div>
                        <div class={"col-lg-10 mb-lg-5 "}>
                            <h2 className="sub-section">
                                {getBrText(realEstate.sections.about.team.paragraph).map((item, index) => (
                                    <>
                                        {item}
                                        <br  className='d-none d-lg-block'/>
                                    </>
                                ))}
                
                            </h2>
                        </div>
                        <div class={"col-lg-10 offset-lg-2 mt-lg-4 my-5 mb-3 mb-lg-0 "  + (realEstate.sections.about.team.hiddenItems && 'd-none')}>
                            <h2 className="my-4 my-lg-0">
                                {realEstate.sections.about.team.subtitle}
                            </h2>
                        </div>
                        <div class={"col-lg-10 offset-lg-2 mt-lg-4 "  + (realEstate.sections.about.team.hiddenItems && 'd-none')}>
                            <div className="row mt-lg-5">
                                {realEstate.sections.about.team.items.map((item, index) => (
                                    <div className="col-lg-4 mb-lg-5">
                                        <div className="card-personal">
                                            {/* <div className="arrow"><i className="icon-arrow" style={{transform:"rotate(90deg)"}}></i></div> */}
                                            <div>
                                                <h4>{item.name}</h4>
                                                <p>{item.type}</p>
                                                <p className={!item.broker_id && 'd-none'}>{item.broker_id}</p>
                                            </div>
                
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        // ):''
    )):''
}

export default Team;